import React, { forwardRef, useImperativeHandle } from 'react';
const Recaptcha = /*#__PURE__*/forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    getRecaptchaToken: async () => {
      if (!grecaptcha) {
        console.log('Execute recaptcha not yet available');
        return;
      }
      const clientId = localStorage ? localStorage.detRecaptchaClientId : '0';
      const token = await grecaptcha.execute(clientId, {
        action: 'yourAction'
      });
      return token;
    }
  }));
  return props.errorMessasge && props.errorMessasge.length ? /*#__PURE__*/React.createElement("div", {
    className: "form-group lr__form-group lr__form-group-captcha"
  }, /*#__PURE__*/React.createElement("p", {
    className: "lr__error form-label-help small error"
  }, props.errorMessasge)) : null;
});
export default Recaptcha;